require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-front-end-libraries-projects.json") })
        }
      }, "path---front-end-libraries-front-end-libraries-projects");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-front-end-libraries-projects!./.cache/json/front-end-libraries-front-end-libraries-projects.json
// module id = 2017
// module chunks = 231608221292675